import React from 'react'
import styled from '@emotion/styled'

const NewLabel = () => <Container>New</Container>

export default NewLabel

const Container = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  color: #ffffff;
  background-color: #00d37e;
  font-family: inter;
  font-size: 12px;
  font-weight: 700;
  line-height: 15px;
  text-align: center;
  padding: 3px 8px;
  margin-left: auto;
`
